/**
 * Capture trial-end promo codes from email links (?promo=ZV3PGBRG).
 */
const PROMO_STORAGE_KEY = "pm_trial_promo_code_v1";

function normalizeCode(raw) {
  return String(raw || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9_-]/g, "")
    .slice(0, 32);
}

export function getStoredPromoCode() {
  try {
    return normalizeCode(window.localStorage.getItem(PROMO_STORAGE_KEY) || "");
  } catch (_) {
    return "";
  }
}

export function setStoredPromoCode(raw) {
  const code = normalizeCode(raw);
  if (!code) return "";
  try {
    window.localStorage.setItem(PROMO_STORAGE_KEY, code);
  } catch (_) {}
  return code;
}

export function clearStoredPromoCode() {
  try {
    window.localStorage.removeItem(PROMO_STORAGE_KEY);
  } catch (_) {}
}

export function capturePromoFromSearch(search) {
  try {
    const params =
      search instanceof URLSearchParams
        ? search
        : new URLSearchParams(String(search || (typeof window !== "undefined" ? window.location.search : "") || ""));
    const raw = params.get("promo") || params.get("coupon") || "";
    return setStoredPromoCode(raw);
  } catch (_) {
    return "";
  }
}

export function buildTrialPromoUrl(promoCode, origin) {
  const code = normalizeCode(promoCode) || "ZV3PGBRG";
  const base =
    String(origin || (typeof window !== "undefined" ? window.location.origin : "") || "").replace(/\/$/, "") ||
    "https://app.pokermoose.com";
  return `${base}/?promo=${encodeURIComponent(code)}`;
}

export function codesMatch(a, b) {
  return !!normalizeCode(a) && normalizeCode(a) === normalizeCode(b);
}
